<template>
    <div>
      <v-card outlined tile style="border: 2px solid #00475a" class="px-5">
        <v-system-bar height="30" color="#fff" class="px-0">
          <span></span>
          <v-spacer></v-spacer>
          <v-icon size="32" class="pt-5" @click="close">mdi-close</v-icon>
        </v-system-bar>
        
        <v-card-title>
          <H6>
            {{ $t("message.superuser.delmessage1", { value: "default" }) }} {{ this.user.name }}.<br> 
            {{ $t("message.superuser.delmessage2", { value: "default" }) }}<br> 
            {{ this.user.name }} {{ $t("message.superuser.delmessage3", { value: "default" }) }}
          </H6></v-card-title
        >
        <div class="btn">
              <v-btn class="mr-2" color="#CCD2D5" @click="cancel">{{
                $t("message.button.cancel", { value: "default" })
              }}</v-btn>
              <v-btn color="#00475A" dark @click="validate" >{{
                $t("message.button.submit", { value: "default" })
              }}</v-btn>
        </div>
      </v-card>
    </div>
  </template>

<script>
import TeamsService from "@/services/TeamsService";
export default {
    props: ["user"],
    data() {
        return {
            type: "info",
            message: "",
        };
    },

    methods: {
        close() {
            this.$emit("deleteClose", this.type);
        },
        cancel() {
            this.$emit("deleteClose", this.type);
        },
        validate(){
            TeamsService.setToDelUserClient(this.user.mail).then(() => {
                this.$emit("deleteClose", this.type);
                
            }).catch(() => {
            this.message = this.$t("message.magic.error", { value: "default" });
            this.type = "error";
            });
        },
    }
}

</script>

<style scoped>
.label-field {
  color: #00475a;
  font: normal normal bold 16px/19px Calibri;
}

.btn {
 display: flex;
 justify-content: space-around;
 padding-bottom: 5px;
}
</style>